var map = {
	"./en/application-renewal-banner.yml": "35de",
	"./en/banner.yml": "811e",
	"./en/customer-profile.yml": "ece5",
	"./en/date-formats.yml": "11a7",
	"./en/en.yml": "214c",
	"./en/loan-navigation.yml": "2bf7a",
	"./en/notifications.yml": "fd77",
	"./en/payment-schedule.yml": "9577",
	"./en/payment.yml": "ed07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c36";